import {
  PermissionRouteGuard,
  type PermissionRouteGuardData,
} from '@exam-management/permission-route-guard';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { QuestionCreationTaskDetailsPageHeader } from '@exam-management/question-creation-task-details';
import { useParams } from '@exam-management/router';
import { Flex } from '@shared/components';
import { Outlet } from 'react-router-dom';

export default function NewQuestionCreationTaskLayout() {
  const { taskId } = useParams('/task-management/question-creation/:taskId');

  const defaultRoutes: PermissionRouteGuardData[] = [
    {
      path: '/task-management/question-creation/:taskId',
      requiredPermission: [APP_PERMISSIONS.TASK.QUESTION_CREATION.VIEW],
      params: {
        taskId,
      },
    },
    {
      path: '/task-management/question-creation/:taskId/details',
      requiredPermission: [APP_PERMISSIONS.TASK.QUESTION_CREATION.VIEW],
      params: {
        taskId,
      },
    },
    {
      path: '/task-management/question-creation/:taskId/question-list',
      requiredPermission: [APP_PERMISSIONS.TASK.QUESTION_CREATION.VIEW],
      params: {
        taskId,
      },
    },
  ];

  return (
    <PermissionRouteGuard routes={defaultRoutes}>
      <Flex sx={{ flexDirection: 'column', height: '100%' }}>
        <QuestionCreationTaskDetailsPageHeader />
        <Outlet />
      </Flex>
    </PermissionRouteGuard>
  );
}
